import React from 'react';

import ApprovedTestsModalPresentation from './ApprovedTestsModalPresentation';

export default class ApprovedTestsModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { handleClickOutPortal, data, currentFilters } = this.props;
        return (
            <ApprovedTestsModalPresentation
                data={data}
                currentFilters={currentFilters}
                handleClickOutPortal={handleClickOutPortal}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tests-conducted/modals/ApprovedTestsModal/index.js